export type BlockedDate = { date: Date; message?: string };
export interface CalendarInlineProps {
  date: Date | null;
  onChange: (newDate: Date) => void;
  dates: Date[];
  blockedDates: BlockedDate[];
}

export interface DateSlot {
  date: Date;
  isBlocked: boolean;
  tooltipMessage?: string;
}

export function getDateSlotKey(date: Date) {
  return `${date.getDate()}-${date.getMonth()}-${date.getFullYear()}`;
}
